import React from "react";
import Legel_Entity_table from "./legel_Entity_table/Legel_Entity_table";
import Legal_Entity_Form from "./legal_Entity_Form/Legal_Entity_Form";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";

function Legel_Entity() {
  return (
    <>
      <section className="Imperiality">
        <div className="back_div">
          <Common_Back_Btn backText="Legel Entity" />
        </div>

        <div className="imperiality_Form_div">
          <Legal_Entity_Form />
        </div>

        <div className="imperiality_table_div">
          <Legel_Entity_table />
        </div>
      </section>
    </>
  );
}

export default Legel_Entity;
